import type {SlotWidgetConfig} from '../types'
import {WidgetType} from '../types'

export const toHeader = (header: SlotWidgetConfig): SlotWidgetConfig => {
  Object.assign(header.slot, {
    // TODO: надо заменить иконку
    lead: {
      icon_spot: {
        icon: {
          image_tag: 'delivery_clock_fill',
          tint_color: 'text',
        },
        background_color: 'controlMinor',
      },
      type: WidgetType.ICON_SPOT,
    },
  })

  return header
}
